import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import {
  createEmergencyContactList,
  deleteEmergencyContactListById,
  updateEmergencyContactListById,
} from '../thunks/emergencyContactLists';

const emergencyContactListsAdapter = createEntityAdapter({});

export const emergencyContactListsSlice = createSlice({
  name: 'emergencyContactLists',
  initialState: emergencyContactListsAdapter.getInitialState({}),
  reducers: {
    setEmergencyContactLists: (state, action) => {
      emergencyContactListsAdapter.upsertMany(state, action.payload);
    },
    addNewEmergencyContactList: (state, action) => {
      emergencyContactListsAdapter.addOne(state, action.payload);
    },
    removeEmergencyContactList: (state, action) => {
      emergencyContactListsAdapter.removeOne(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createEmergencyContactList.fulfilled, (state, action) => {
        emergencyContactListsAdapter.upsertOne(state, action.payload);
      })
      .addCase(deleteEmergencyContactListById.fulfilled, (state, action) => {
        const { id } = action.payload;
        emergencyContactListsAdapter.removeOne(state, id);
      })
      .addCase(updateEmergencyContactListById.fulfilled, (state, action) => {
        const { id } = action.payload;
        emergencyContactListsAdapter.updateOne(state, {
          id,
          changes: action.payload,
        });
      });
  },
});

export const {
  setEmergencyContactLists,
  addNewEmergencyContactList,
  removeEmergencyContactList,
} = emergencyContactListsSlice.actions;

export const emergencyContactListsAdapterSelectors =
  emergencyContactListsAdapter.getSelectors(
    (state) => state.emergencyContactLists
  );

export default emergencyContactListsSlice.reducer;
